module.exports = __webpack_public_path__ + "static/media/TaskFile.4a5e8f69.png";